<mat-form-field [formGroup]="group" class="select" appearance="outline">
  <mat-label>{{ this.config.label }}{{ isRequired ? ' *' : '' }}</mat-label>
  <input
    class="mat-form-field uppercase"
    matInput
    [attr.placeholder]="config.placeholder"
    [value]="displayValueForTemplate"
    [readonly]="true" />
  <button
    *ngIf="typeCes !== typeCesEnum.SHOW"
    matSuffix
    mat-icon-button
    aria-label="Clear"
    (click)="openSelectCrud()">
    <mat-icon [ngStyle]="{ color: '#707070' }">arrow_drop_down</mat-icon>
  </button>
  <button
    mat-icon-button
    matSuffix
    *ngIf="(group.get(config.name)?.value || displayValue) && typeCes !== typeCesEnum.SHOW && !group.get(config.name)?.disabled"
    (click)="clear()">
    <mat-icon [ngStyle]="{ color: '#707070' }">close</mat-icon>
  </button>
</mat-form-field>
<ng-content></ng-content>
